function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { Chevron } from '@bnnvara/icons/src/components/UserInterfaceIcons/Chevron';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import SlickSlider from 'react-slick';
import * as S from './styled';
const prevArrow = /*#__PURE__*/React.createElement(S.PrevArrow, null, /*#__PURE__*/React.createElement(Chevron, null));
const nextArrow = /*#__PURE__*/React.createElement(S.NextArrow, null, /*#__PURE__*/React.createElement(Chevron, null));
let sliderSettings = {
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: true,
  initialSlide: 0
};
let responsive = [{
  breakpoint: 320,
  settings: {
    slidesToShow: 2,
    slidesToScroll: 1
  }
}, {
  breakpoint: 768,
  settings: {
    slidesToShow: 2,
    slidesToScroll: 1
  }
}, {
  breakpoint: 1024,
  settings: {
    slidesToShow: 3,
    slidesToScroll: 1
  }
}];

const Slider = props => {
  const [isClient, setClientState] = useState(false); // this is needed because of this issue in react-slick: https://github.com/akiran/react-slick/issues/1245

  useEffect(() => {
    setClientState(true);
  }, [setClientState]);
  const {
    isBrand,
    className,
    arrows
  } = props;

  if (isBrand) {
    sliderSettings = {
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      initialSlide: 0
    };
    responsive = [{
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 1440,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }];
  }

  return /*#__PURE__*/React.createElement(S.SliderBase, {
    isBrand: isBrand,
    arrows: arrows,
    className: className
  }, /*#__PURE__*/React.createElement(S.GlobalStyle, null), /*#__PURE__*/React.createElement(SlickSlider, _extends({
    key: isClient ? 'client' : 'server',
    responsive: isClient ? responsive : null,
    speed: 500,
    prevArrow: prevArrow,
    nextArrow: nextArrow
  }, sliderSettings, props)));
};

Slider.defaultProps = {
  isBrand: false,
  arrows: true
};
Slider.propTypes = {
  isBrand: PropTypes.bool,
  className: PropTypes.string.isRequired,
  arrows: PropTypes.bool
};
export default Slider;